import React, { useState } from "react";
import { IFormField } from "utils/form-utils";
import { FormField } from "components/shared-ui/form/form-field/form-field";
import TextInput from "components/shared-ui/input/text-input/text-input";
import { Check, ContentCopy } from "@mui/icons-material";
import styles from "./mfa-device-manual-section.module.scss";
import Button from "components/shared-ui/button";
export interface IMfaDeviceManualSectionProps {
  nameField: IFormField<string>;
  codeField: IFormField<string>;
  secretValue: string;
  copied?: boolean;
  onCopy?: () => void;
  testId?: string;
}

export default function MfaDeviceManualSection(
  props: IMfaDeviceManualSectionProps,
) {
  const [copied, setCopied] = useState(false);
  const copySecretToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(props.secretValue || "");
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy secret:", err);
    }
  };

  const testId = props.testId ?? "mfa-device-manual-section";

  return (
    <div data-testid={testId} className={styles.manualSetupSection}>
      <div>
        <div className={styles.secret}>
          <span>Secret:</span>
          <span>{props.secretValue || ""}</span>
          <Button
            // type="button"
            onClick={props.onCopy ?? copySecretToClipboard}
            // title="Copy secret"
            testId="mfa-secret-copy-btn"
            className={styles.copyButton}
            aria-label="copy-secret"
          >
            {copied || props.copied ? <Check /> : <ContentCopy />}
          </Button>
        </div>
      </div>

      <FormField
        label="Name"
        testId="mfa-name-field"
        className={styles.codeInput}
      >
        <TextInput field={props.nameField} testId="mfa-name-input" />
      </FormField>

      {props.codeField && (
        <FormField
          label="One-time code"
          testId="mfa-code-field"
          className={styles.codeInput}
        >
          <TextInput field={props.codeField} testId="mfa-code-input" />
        </FormField>
      )}
    </div>
  );
}
